// extracted by mini-css-extract-plugin
export var card = "_0-1";
export var shell = "_0-0";
export var subtitle = "_0-3";
export var title = "_0-2";